import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges, OnChanges } from '@angular/core';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'

/**
 * Modal confirmation dialog for destructive delete operations.
 *
 * Supports two confirmation modes controlled by `typeConfirmation`:
 * - **Click mode** (`typeConfirmation = false`): a single OK button is sufficient.
 * - **Type mode** (`typeConfirmation = true`): the user must type `confirmText`
 *   exactly into an input before the confirm button is enabled.
 *
 * `onShowDialog` resets `deleteConfirmStr` each time the dialog opens so a
 * previous entry cannot carry over.  On confirm, `done` emits `true`.
 * `displayChange` emits `false` on hide to support two-way `[(display)]` binding.
 */
@Component({
  selector: 'app-confirm-delete-product-part',
  templateUrl: './confirm-delete-product-part.component.html',
  styleUrls: ['./confirm-delete-product-part.component.css']
})
export class ConfirmDeleteProductPartComponent implements OnInit, OnChanges, OnDestroy  {

  /** Controls dialog visibility; supports two-way binding via `displayChange`. */
  @Input() display: boolean = false;

  /** Text shown in the dialog title bar. */
  @Input() header: string = 'Подтвердите удаление...';

  /** When true, the user must type `confirmText` exactly to enable the confirm button. */
  @Input() typeConfirmation: boolean = false;

  /** The exact string the user must type when `typeConfirmation` is true. */
  @Input() confirmText: string = 'DELETE';

  /** Warning message body shown inside the dialog. */
  @Input() messageText: string = 'Предупреждение - неоходимо подтверждение';

  deleteConfirmStr: string = '';

  /** True when click-mode is active, or when the user has typed `confirmText` exactly. */
  public get canConfirm(): boolean {
    return (!this.typeConfirmation || (this.deleteConfirmStr == this.confirmText)) ? true : false;
  }

  /** Emits `false` on dialog hide to support two-way `[(display)]` binding. */
  @Output() displayChange = new EventEmitter();

  /** Emits `true` when the user confirms the delete action. */
  @Output() done = new EventEmitter<boolean>();

  modal: boolean = true;

  settings: GlobalSettingsData;

  constructor(
  ) {
  }

  /** No subscriptions to clean up. */
  ngOnDestroy() {
  }

  /** No-op — reacts to input changes but no action needed for current inputs. */
  ngOnChanges(changes: SimpleChanges) {
      //console.log('*** ConfirmDeleteProductPartComponent ngOnChanges: ');
    for (let propName in changes) {
      let change = changes[propName];

      //console.log('*** ConfirmDeleteProductPartComponent ngOnChanges (was):    ' + propName + ' ' + JSON.stringify(change.previousValue));
      console.log('*** ConfirmDeleteProductPartComponent ngOnChanges (actual): ' + propName + ' ' + JSON.stringify(change.currentValue));

      switch (propName) {
        case 'parentCompany':
        break;
      }
    }
  }

  /** No-op initialisation. */
  ngOnInit(): void {
    console.log('*** ConfirmDeleteProductPartComponent onInit');
  }

  /** Resets `deleteConfirmStr` each time the dialog opens to prevent carry-over from a previous session. */
  onShowDialog() {
    console.log('*** ConfirmDeleteProductPartComponent onShow: ');
    this.deleteConfirmStr = '';
  }

  /** Emits `false` via `displayChange` to close the dialog. */
  onHideDialog() {
    console.log('*** ConfirmDeleteProductPartComponent onHide');
    this.displayChange.emit(false);
  }

  /** Enter-key shortcut — delegates to `onConfirm` when `canConfirm` is true. */
  doConfirm(event) {
    console.log('*** ConfirmDeleteProductPartComponent doConfirm: ' + JSON.stringify(event));
    if (this.canConfirm) this.onConfirm('enter');
  }

  /** Emits `true` via `done` and closes the dialog. */
  onConfirm(text: string) {
    console.log('*** ConfirmDeleteProductPartComponent onConfirm: ' + text);
    if (this.canConfirm) {
      this.done.emit(true);
      this.display = false;
    }
  }

}
